
        // =======================================================================
        // Adtech / location data-broker directory + DSAR letter templates.
        //
        // A curated, best-effort list of the major brokers who buy and sell
        // mobile location history. Contacts are the published privacy / data-
        // subject-request addresses at the time of writing — ALWAYS confirm the
        // current address on the broker's privacy page before sending, and keep
        // proof of delivery. This list is guidance, not legal advice.
        // =======================================================================
        const AEA_BROKERS = [
            { name: 'Acxiom', contact: 'privacy@acxiom.com',
              note: 'Global data broker; consumer portal at isapps.acxiom.com.' },
            { name: 'Oracle Advertising (Data Cloud)', contact: 'privacy_ww@oracle.com',
              note: 'BlueKai / Datalogix lineage. Oracle is winding down its ad business — request current holdings.' },
            { name: 'Experian Marketing Services', contact: 'privacy@experian.com',
              note: 'Distinct from the credit bureau file — ask specifically for marketing/mobile location data.' },
            { name: 'Epsilon (Publicis)', contact: 'privacy@epsilon.com',
              note: 'CORE ID / Conversant. Large offline+online identity graph.' },
            { name: 'LiveRamp', contact: 'privacy@liveramp.com',
              note: 'Identity resolution; may direct you to the originating data source.' },
            { name: 'Kochava / Kochava Collective', contact: 'privacy@kochava.com',
              note: 'Mobile attribution + a large location marketplace.' },
            { name: 'Gravy Analytics / Venntel', contact: 'privacy@gravyanalytics.com',
              note: 'Precise-location aggregator (Venntel is the government-facing arm).' },
            { name: 'Outlogic (formerly X-Mode)', contact: 'privacy@outlogic.io',
              note: 'Location SDK data; named in FTC enforcement — request deletion explicitly.' },
            { name: 'Foursquare (incl. Factual/Placed)', contact: 'privacy@foursquare.com',
              note: 'Places graph + visitation data via its SDK partners.' },
            { name: 'Precisely (PlaceIQ)', contact: 'privacy@precisely.com',
              note: 'PlaceIQ location-audience data.' },
            { name: 'Near Intelligence', contact: 'privacy@near.com',
              note: 'Global location-intelligence marketplace.' },
            { name: 'Adsquare', contact: 'privacy@adsquare.com',
              note: 'EU-based location/audience exchange.' },
            { name: 'Tamoco', contact: 'privacy@tamoco.com',
              note: 'Location SDK / sensor data.' },
            { name: 'The Trade Desk', contact: 'privacy@thetradedesk.com',
              note: 'DSP — request the identity/segment data held against the ID.' },
            { name: 'Lotame', contact: 'privacy@lotame.com',
              note: 'Data-management platform / audience segments.' },
            { name: 'Equifax (marketing data)', contact: 'privacy@equifax.com',
              note: 'IXI/marketing division, distinct from the credit file.' },
            { name: 'Other / not listed', contact: '',
              note: 'Enter the broker name and their published privacy contact manually.' },
        ];

        const AEA_REQUEST_TYPES = [
            { value: 'article_15', label: 'Access (Art. 15)',
              blurb: 'Ask what location data they hold, its sources, and who they shared it with.' },
            { value: 'article_17', label: 'Erasure (Art. 17)',
              blurb: 'Demand deletion of the location data held against this device.' },
            { value: 'article_21', label: 'Objection (Art. 21)',
              blurb: 'Object to further processing/selling for direct-marketing purposes (must be honoured).' },
        ];

        // Build a ready-to-send data-subject-request letter for a broker.
        function aeaDsarLetter({ broker, contact, subjectName, requestType, maidTail }) {
            const today = new Date().toLocaleDateString('en-GB', { year: 'numeric', month: 'long', day: 'numeric' });
            const idLine = maidTail
                ? `Mobile advertising identifier (last 4 characters, for matching only): …${maidTail}`
                : 'Mobile advertising identifier: [supplied separately / see attached signed authority]';
            const who = subjectName || '[data subject name]';
            const b = broker || '[broker name]';

            const access = `I am writing on behalf of ${who} to make a Subject Access Request under Article 15 of the UK GDPR / EU GDPR (and analogous rights under CCPA/CPRA where applicable).

Please provide, within one month:
  1. Confirmation of whether you process personal data — including precise or approximate location history — associated with the identifier below.
  2. A copy of all such personal data, in a portable format (CSV/JSON) where the data is location points.
  3. The sources from which you obtained it.
  4. The categories of recipients you have disclosed or sold it to.
  5. The retention period applied.`;

            const erasure = `I am writing on behalf of ${who} to exercise the right to erasure under Article 17 of the UK GDPR / EU GDPR (and the right to delete under CCPA/CPRA where applicable).

Please erase, within one month, all personal data — including all location history — held against the identifier below, and instruct any recipients to whom you have disclosed or sold it to do the same. Please confirm in writing once erasure is complete and identify any data you are retaining and the lawful ground for doing so.`;

            const objection = `I am writing on behalf of ${who} to object, under Article 21 of the UK GDPR / EU GDPR, to the processing of their personal data — including location history — for direct-marketing purposes, and to opt out of any sale or sharing of that data under CCPA/CPRA where applicable.

This objection to direct-marketing processing is absolute and must be actioned without further justification. Please confirm you have ceased such processing and will not sell or share this data going forward.`;

            const body = requestType === 'article_17' ? erasure
                       : requestType === 'article_21' ? objection : access;

            return `To: ${contact || '[broker privacy contact]'}
Date: ${today}
Re: Data subject request — ${b}

${body}

Identifying details:
  Data subject: ${who}
  ${idLine}

I attach the data subject's signed authority for me to act on their behalf. I am not required to pay a fee for this request. If you need anything further to verify identity, contact me before the statutory deadline rather than closing the request.

Please treat this as formal notice of the request and the start of the statutory response period.

Yours faithfully,
[Analyst name]
[Firm] — acting under written authority`;
        }

export { AEA_BROKERS, AEA_REQUEST_TYPES, aeaDsarLetter };
